var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 24,
    viewBox: "0 0 70 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0607 13.0861C69.6464 12.5003 69.6464 11.5505 69.0607 10.9647L59.5147 1.41879C58.9289 0.833002 57.9792 0.833002 57.3934 1.41879C56.8076 2.00458 56.8076 2.95432 57.3934 3.54011L65.8787 12.0254L57.3934 20.5107C56.8076 21.0965 56.8076 22.0462 57.3934 22.632C57.9792 23.2178 58.9289 23.2178 59.5147 22.632L69.0607 13.0861ZM0 13.5254H68V10.5254H0V13.5254Z",
    fill: "#05994F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/greenArrow.b5816cd2cb66bcbd2a5d674f82902f48.svg";
export { ForwardRef as ReactComponent };